import React, { useState, useEffect } from 'react';
import './CreateProfile.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import Banner1 from './5.JPG'
import arrow from './arrow.png'


import { HashRouter as Router, Routes, Route } from 'react-router-dom';

function CreateProfile() {
    const navigate = useNavigate();

 
  
    return (
        <div className="createProfile">
            <div className="load">
                <hr />
                <hr />
                <hr />
                <hr />
            </div>

            <div className="ugf-wrapper theme-bg">
                <div className="ugf-content-block">
                 
                    <div className="container-md">
                        <div className="row">
                            <div className="col-lg-7 offset-lg-5 p-sm-0">
                                <div className="ugf-content pt270">
                                    <h2><span> Registration Page</span></h2>
                                    <p>Here, you can register as an individual, an association/club, or a sports club. Additionally, if you're interested in our empowerment programs, you can apply through the empowerment application form.

</p>
                                    <Link to="/Youth_Registration">
                                    <form  className="form-flex email-form" id="commentForm">
                                        <button className="btn"><span>Individual</span> <img src={arrow} alt="arrow" width="20%" /></button>
                                    </form>
                                   </Link>
                                   <Link to="/Associations_Registration">
                                    <form  className="form-flex email-form" id="commentForm">
                                        <button className="btn"><span>Association</span> <img src={arrow} alt="arrow" width="20%" /></button>
                                    </form>
                                   </Link>
                                   <Link to="/Sports_Club_Registration">
                                    <form  className="form-flex email-form" id="commentForm">
                                        <button className="btn"><span>Sports Clubs</span> <img src={arrow} alt="arrow" width="20%" /></button>
                                    </form>
                                   </Link>
                                   <Link to="/Empowerment_Application">
                                    <form  className="form-flex email-form" id="commentForm">
                                        <button className="btn"><span>Empowerment</span> <img src={arrow} alt="arrow" width="20%" /></button>
                                    </form>
                                   </Link>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="alternet-access">
                        <p>Already have an account? <Link to="/Home"> Log in now!</Link> </p>
                        
                    </div>
                    
                </div>
         
              
             <div className="ugf-sidebar flex-bottom ugf-sidebar-bg">
             {/* <img src={Banner1} alt='banner' className='bannerImage'></img> */}
                   
                </div> 
                <div className="footer">
      <a href="https://techlife.ng">© 2024 All Rights Reserved. Developed By Techlife.</a>
  </div>
          
    
            </div>
            
        </div>
        
    );
}

export default CreateProfile;
